export default "__VITE_ASSET__9f292b21__"